import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {TestType} from '../../enums/test-type';
import {NormalTest} from "../../models/test";
import {ResultType} from "../../enums/result-type";
import {ValidationCallbackData} from "devextreme/ui/validation_rules";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-mass-result-entry-dialog',
  templateUrl: './mass-result-entry-dialog.component.html',
  styleUrls: ['./mass-result-entry-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MassResultEntryDialogComponent {
  @Input() public popupVisible: boolean = false;
  @Input() public test?: NormalTest;
  @Output() public closeEvent = new EventEmitter();
  public titerRegex = /^\d{1,3}(:\d+)$/
  public form: FormGroup = new FormGroup({
    numeric: this.fb.control(''),
    alpha: this.fb.control(''),
    titer: this.fb.control('', [Validators.pattern(this.titerRegex)]),
    open: this.fb.control('')
  });

  constructor(private fb: FormBuilder) {
    this.validateItem = this.validateItem.bind(this);
  }

  public close(): void {
    this.clean();
    this.closeEvent.emit();
  }

  public getAlphaResults(): string[] {
    if (!this.test) return [];
    if (!this.test.alphaClinicalRanges) return [];
    return this.test.alphaClinicalRanges?.map(cr => cr.result);
  }

  public get IsNumeric() {
    return this.TestResultType === ResultType.ValueValue || this.TestResultType ===  ResultType.GreaterEqualValue ||
      this.TestResultType === ResultType.LessEqualValue || this.TestResultType === ResultType.GreaterThanValue ||
      this.TestResultType === ResultType.LessThanValue || this.TestResultType === ResultType.SpecificCutOff;
  }

  public get IsTiter() {
    return this.TestResultType === ResultType.Titer;
  }

  public get IsOpen() {
    return this.TestResultType === ResultType.OpenResultWithoutUnit || this.TestResultType === ResultType.OpenResultWithUnit;
  }

  public get IsAlpha() {
    return this.TestResultType === ResultType.AlphaResults;
  }

  public get TestResultType() {
    if (!this.test) return TestType.None;
    return this.test.resultType;
  }

  public validateItem(event: ValidationCallbackData) {
    if (event.value === '') return true;

    switch (this.test?.resultType) {
      case ResultType.ValueValue:
      case ResultType.GreaterEqualValue:
      case ResultType.LessEqualValue:
      case ResultType.GreaterThanValue:
      case ResultType.LessThanValue: {
        const res = Number(event.value);
        const message = res ? "" : "The result value is not valid.";
        event.validator.option("validationRules[0].message", message);

        return res;
      }
      case ResultType.AlphaResults:
        return true;
      case ResultType.OpenResultWithUnit:
      case ResultType.OpenResultWithoutUnit:
        return true;
      case ResultType.Titer: {
        const res = this.titerRegex.test(event.value as string);
        const message = !res ? "" : "The titer value is not valid.";
        event.validator.option("validationRules[0].message", message);

        return res;
      }
      case ResultType.SpecificCutOff: {
        const res = Number(event.value);
        const message = res ? "" : "The result value is not valid.";
        event.validator.option("validationRules[0].message", message);

        return res;
      }
    }

    return true;
  }

  public clean() {
    this.form.reset({
      numeric: '',
      alpha: '',
      titer: '',
      open: ''
    });
    this.form.markAsPristine();
  }

  public submit() {
    if (this.form.valid) {
      this.popupVisible = false;
    }
  }

  public hidden() {
    const values = this.form.value;
    this.clean();
    const result = values.numeric !== '' ? values.numeric : values.alpha !== '' ? values.alpha : values.titer !== '' ? values.titer : values.open;
    this.closeEvent.emit(result);
  }
}
